import { NetworkApi } from 'network';
import {
	DestinationDto,
	DestinationFilters,
	DestinationListItem,
	DestinationsDeleteResult,
} from 'types/Destination';
import { List } from 'types/List';

export class DestinationsService extends NetworkApi {
	public static getDestinations(
		accountId: string,
		filters?: DestinationFilters,
	) {
		return this.get<List<DestinationListItem>, DestinationFilters>(
			`/accounts/${accountId}/destinations`,
			filters,
		);
	}

	public static createDestination(
		accountId: string,
		destination: DestinationDto,
	) {
		return this.post<{ id: string }, DestinationDto, void>(
			`/accounts/${accountId}/destinations`,
			destination,
		);
	}

	public static updateDestination(
		accountId: string,
		destinationId: string,
		destination: Partial<DestinationDto>,
	) {
		return this.patch<void, Partial<DestinationDto>, void>(
			`/accounts/${accountId}/destinations/${destinationId}`,
			destination,
		);
	}

	public static bulkDeleteDestinations(
		accountId: string,
		destinationIds: string[],
		mfaToken?: string,
	) {
		return this.delete<
			DestinationsDeleteResult,
			{ account_destination_ids: string[] },
			{ [key: string]: string }
		>(
			`/accounts/${accountId}/destinations/bulk-delete`,
			{ account_destination_ids: destinationIds },
			mfaToken ? { 'x-mfa-code': mfaToken } : undefined,
		);
	}

	public static deleteDestination(
		accountId: string,
		destinationId: string,
		mfaToken?: string,
	) {
		return this.delete<void, undefined, { [key: string]: string }>(
			`/accounts/${accountId}/destinations/${destinationId}`,
			undefined,
			mfaToken ? { 'x-mfa-code': mfaToken } : undefined,
		);
	}
}
